import { FormControl } from '@angular/forms';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';

export enum TSFNNewRequestAdditionalControlName {
  TreesNumber = 'treesNumber',
  TreesDescription = 'treesDescription',
}

export const TSFNNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...TSFNNewRequestAdditionalControlName,
};

export interface TSFNNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [TSFNNewRequestControlName.TreesNumber]: FormControl<number>;
  [TSFNNewRequestControlName.TreesDescription]: FormControl<string>;
}
